import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f6dda90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-5 -mt-10" }
const _hoisted_2 = { class: "flex space-x-24 px-5 opacity-[50%]" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { className: " border-[1px] my-2 w-[26rem]" }, null, -1))

import { PropType } from "vue"
import {
	ModalContainer,
	ModalContentContainer,
	H1,
	ShowReasonContainer,
	Paragraph,
} from "../atoms"



export default /*#__PURE__*/_defineComponent({
  __name: 'FitDisplayModal',
  props: {
	adjustment: {
		type: Array as PropType<any[]>,
		required: true,
	},
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(_unref(ModalContainer), null, {
    default: _withCtx(() => [
      _createVNode(_unref(ModalContentContainer), {
        w: "33rem",
        h: "30rem",
        class: "px-10"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", {
              class: "px-2 float-right w-8 active:scale-90",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeModal', false)))
            }, [
              _createVNode(_component_v_icon, { icon: "mdi-close-thick" })
            ])
          ]),
          _createVNode(_unref(H1), { class: "text-v_dark_blue -mt-8" }, {
            default: _withCtx(() => [
              _createTextVNode("Ajustes")
            ]),
            _: 1
          }),
          _createVNode(_unref(ShowReasonContainer), { class: "space-y-2 bg-white mt-2" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(Paragraph), null, {
                  default: _withCtx(() => [
                    _createTextVNode("Descrição do Ajuste:")
                  ]),
                  _: 1
                }),
                _createVNode(_unref(Paragraph), null, {
                  default: _withCtx(() => [
                    _createTextVNode("Valor Ajustado:")
                  ]),
                  _: 1
                })
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.adjustment, (adjust) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "Grid",
                  key: adjust.Id
                }, [
                  _createVNode(_unref(Paragraph), { class: "break-words w-40 ml-[1rem]" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(adjust.description), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_unref(Paragraph), {
                    class: _normalizeClass(
							Number(adjust.value) > 0 ? 'text-v_green ml-6' : 'text-v_red ml-6'
						)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(Number(adjust.value).toLocaleString("pt-BR", {
								style: "currency",
								currency: "BRL",
							})), 1)
                    ]),
                    _: 2
                  }, 1032, ["class"]),
                  _hoisted_3
                ]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})